module.exports = __webpack_public_path__ + "img/box.132bd812.svg";